import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { getVendorDetails } from "../api/vendorDetails";
import VendorHeader from "../components/vendors/VendorHeader";
import { updateVendorAutoAcceptLimit } from "../api/vendorDetails";
import VendorDocumentsGrid from "../components/vendors/VendorDocumentsGrid";
import { Box, Stack, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAppTranslation } from "../hooks/useAppTranslation";
import VendorBankAccountsModal from "../components/vendors/VendorBankAccountsModal";

type Props = {
  companyId: string;
};

export default function VendorDetailsPage({ companyId }: Props) {
  const { t } = useAppTranslation("common");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [vendor, setVendor] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);
  const [bankAccountsOpen, setBankAccountsOpen] = React.useState(false);

  const handleOpenBankAccounts = () => {
    setBankAccountsOpen(true);
  };

  React.useEffect(() => {
    if (!id) return;

    setLoading(true);
    getVendorDetails(companyId, id)
      .then(setVendor)
      .finally(() => setLoading(false));
  }, [companyId, id]);

  if (loading) {
    return <CircularProgress />;
  }

  if (!vendor) {
    return <div>{t("Nie znaleziono dostawcy")}</div>;
  }

  const handleSaveLimit = async (value: number) => {
    if (!id) return;

    await updateVendorAutoAcceptLimit(companyId, id, value);

    setVendor((prev: any) => ({
        ...prev,
        autoAcceptLimit: value,
    }));
  };

  const handleBack = () => {
    navigate(`/vendors`);
  };


  return (
    <Stack sx={{ flex: 1, minHeight: 0, p: 2 }}>
        <Button
          variant="text"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            alignSelf: "flex-start",
            mb: 1,
          }}
        >
          {t("Dostawcy")}
        </Button>

        <Box
        sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "320px 1fr" },
            gap: 2,
            flex: 1,
            minHeight: 0,
        }}
        >
        {/* LEWA KOLUMNA – DOSTAWCA */}
        <VendorHeader
            vendor={vendor}
            onSaveLimit={handleSaveLimit}
            onOpenBankAccounts={handleOpenBankAccounts}
        />

        {/* PRAWA KOLUMNA – DOKUMENTY */}
        <Stack sx={{ flex: 1, minHeight: 0 }}>
          <VendorDocumentsGrid
            companyId={companyId}
            vendorId={id}
            onRowClick={(docId) => {
              navigate(`/document/${docId}?companyId=${companyId}`);
            }}
          />
        </Stack>
        </Box>
        <VendorBankAccountsModal
          open={bankAccountsOpen}
          onClose={() => setBankAccountsOpen(false)}
          companyId={companyId}
          vendorId={id!}
        />
    </Stack>
  );
}
